import { isNetworkError } from '~~/types/NetworkError';
import { captureApiError, endpointKey, type ApiErrorSource } from '~/utils/captureApiError';
import { reportNetworkError } from '~/utils/reportNetworkError';

export type ReportRequestFailureOptions = {
	error: unknown;
	source: ApiErrorSource;
	/** `queryKey[0]` or `mutationKey[0]`; only used to label network errors, which carry no status. */
	key?: string;
	/** `query.state.dataUpdatedAt`; `null` when there is no success to compare against. */
	lastSuccessAt: number | null;
	tags?: Record<string, string | number | boolean>;
	contexts?: Record<string, Record<string, unknown>>;
};

export const reportRequestFailure = ({ error, source, key, lastSuccessAt, tags, contexts }: ReportRequestFailureOptions) => {
	if (isNetworkError(error)) {
		reportNetworkError({ error, source, key: key ?? endpointKey(error), lastSuccessAt });
		return;
	}

	captureApiError({ error, source, tags, contexts });
};
